import { application } from "./application"

import ToastController      from "./toast_controller"
import SearchController     from "./search_controller"
import ModalController      from "./modal_controller"
import ModalCloseController from "./modal_close_controller"
import TomselectController  from "./tomselect_controller"
import MenuLeftController   from "./menu_left_controller"
import BulkSelectController from "./bulk_select_controller"
import DirtyRowsController  from "./dirty_rows_controller"
import ClipboardController  from "./clipboard_controller"
import ReviewQueueController from "./review_queue_controller"

application.register("toast",        ToastController)
application.register("search",       SearchController)
application.register("modal",        ModalController)
application.register("modal-close",  ModalCloseController)
application.register("tomselect",    TomselectController)
application.register("menu-left",    MenuLeftController)
application.register("bulk-select",  BulkSelectController)
application.register("dirty-rows",   DirtyRowsController)
application.register("clipboard",    ClipboardController)
application.register("review-queue", ReviewQueueController)
